import { Pipe, PipeTransform } from '@angular/core';
import { Amount } from '@evermile/customer-service';

@Pipe({
  name: 'price',
  standalone: true,
})
export class PricePipe implements PipeTransform {
  transform(amount: Amount | null | undefined): string {
    if (amount?.valueCents === null || amount?.valueCents === undefined) {
      return '';
    }

    const formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: amount.currency || 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formatter.format(amount.valueCents / 100);
  }
}
